import { FiX, FiChevronLeft } from "react-icons/fi";

export default function CatalogSheetHeader({
  title,
  canGoBack,
  onBack,
  onClose,
  t,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onPointerCancel,
}) {
  return (
    <>
      <div
        className="csHandleWrap"
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerCancel}
      >
        <div className="csHandle" />
      </div>

      <div
        className="csTopBar"
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerCancel}
      >
        <div className="csTopLeft">
          {canGoBack ? (
            <button
              type="button"
              className="csBackBtn"
              onClick={onBack}
              aria-label={t("back")}
              title={t("back")}
            >
              <FiChevronLeft className="csBackIcon" />
            </button>
          ) : (
            <div className="csBackStub" />
          )}

          <div className="csTitle">{title}</div>
        </div>

        <button
          type="button"
          className="csIconBtn"
          onClick={onClose}
          aria-label={t("close")}
          title={t("close")}
        >
          <FiX className="csIcon" />
        </button>
      </div>
    </>
  );
}